(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-freight-request"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const panel = document.getElementById('sa-freight-request');
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    if (panel.querySelector('[data-freight-success], .errors')) panel.open = true;
    const cart = document.getElementById('cart');
    const form = document.getElementById('StrongarmFreightRequest');
    if (!cart || !form) return;
    let changed = false;
    cart.addEventListener('input', () => { changed = true; });
    cart.addEventListener('change', () => { changed = true; });
    form.addEventListener('submit', event => {
      if (!changed) return;
      event.preventDefault();
      const error = panel.querySelector('.sa-freight-error');
      error.hidden = false;
      error.scrollIntoView({block: 'center'});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sa-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-product-gallery')) {
  customElements.define('sa-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.sa-media-track');
      this.slides = [...this.querySelectorAll('.sa-media-slide')];
      this.thumbs = [...this.querySelectorAll('[data-media-target]')];
      this.index = Math.max(0, this.slides.findIndex(s => s.dataset.mediaId === this.dataset.initial));
      this.querySelector('[data-media-prev]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-media-next]').addEventListener('click', () => this.go(this.index + 1));
      this.querySelector('[data-media-watch]')?.addEventListener('click', () => this.go(this.slides.findIndex(s => s.querySelector('video,iframe'))));
      this.thumbs.forEach((b, i) => b.addEventListener('click', () => this.go(i)));
      this.track.addEventListener('scroll', () => {
        const next = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (next !== this.index) { this.index = next; this.update(); }
      }, {passive:true});
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.observer = new ResizeObserver(() => this.go(this.index));
      this.observer.observe(this.track);
      this.go(this.index);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    go(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:'instant'});
      this.update();
    }
    update() {
      this.slides.forEach((s, i) => {
        s.inert = i !== this.index;
        if (i !== this.index) {
          s.querySelectorAll('video').forEach(v => v.pause());
          s.querySelectorAll('iframe').forEach(f => {
            if (f.dataset.wasActive === 'true') { f.src = f.src; f.dataset.wasActive = 'false'; }
          });
        } else s.querySelectorAll('iframe').forEach(f => { f.dataset.wasActive = 'true'; });
      });
      this.thumbs.forEach((b,i) => b.setAttribute('aria-pressed', String(i === this.index)));
      const thumb = this.thumbs[this.index];
      if (thumb) {
        const strip = thumb.parentElement;
        strip.scrollTo({left:thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth)/2, behavior:'instant'});
      }
      this.querySelector('[data-media-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelector('[data-media-prev]').disabled = this.index === 0;
      this.querySelector('[data-media-next]').disabled = this.index === this.slides.length - 1;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
